import React from "react";

export function PosterFooter({ userName }) {
  return (
    <div
      className="pt-4 mt-2 border-t border-white/10 flex-shrink-0"
      style={{ paddingBottom: 4, minHeight: 32 }}
    >
      <p
        className="text-[10px] text-white/60 truncate"
        style={{ lineHeight: 1.6 }}
      >
        {userName || "JesCook"}
      </p>
    </div>
  );
}
